import { Component, inject, input, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SidebarOpenSearchComponent } from '../sidebar-open-search/sidebar-open-search.component';
import { SearchType } from '../../enums/search-type';

@Component({
  selector: 'app-error-not-found-404',
  imports: [MatIconModule, TranslateModule],
  templateUrl: './error-not-found-404.component.html',
  styleUrl: './error-not-found-404.component.scss',
})
export class ErrorNotFound404Component {
  private sidebarComponent = inject(SidebarOpenSearchComponent);
  new = signal(SearchType.NEW);
  hideButton = input<boolean>(false);
  goOpenSearch() {
    this.sidebarComponent.togglePanelbar(this.new());
  }
}
